<div class="row p-1">
  <div class="col-12 pageTitle pl-0">
    <h2>&nbsp;&nbsp;&nbsp;Emergency Token</h2>
  </div>
</div>

<div class="grid mt-1">
  <div class="card card-w-title col-11 md:col-4 ml-2">
    <div class="emergencyToken">
      <h3 class="p-message alignCenter">Emergency Token</h3>
    </div>
    <div class="ml-5">
      <div class="grid">
        <form
          [formGroup]="emergencyToken"
          (ngSubmit)="resetToken()"
          class="w-12"
        >
          <div class="col-12 ml-1">
            <span class="field p-float-label">
              <input
                id="float-input"
                type="password"
                appFormErrorMessages
                pInputText
                formControlName="emergencyToken"
                class="text-base text-color p-2 col-11"
                autocomplete="off"
              />
              <label for="float-input">
                <span class="required-asteric"> * </span>Emergency Token</label
              >
            </span>
          </div>

          <div class="col-12 ml-1">
            <span class="field p-float-label">
              <input
                id="float-input2"
                type="password"
                appFormErrorMessages
                pInputText
                formControlName="confirmemergencyToken"
                class="text-base text-color p-2 col-11"
                autocomplete="off"
              />
              <label for="float-input1">
                <span class="required-asteric"> * </span>Confirm Emergency
                Token</label
              >
            </span>
          </div>

          <div class="col-12">
            <button
              pButton
              type="submit"
              label="Save"
              icon="pi pi-save"
              class="p-button-plain buttonWidth-7 fl"
            ></button>
          </div>
        </form>

        <div
          class="col-12 p-messagesp-messages-summary border-radius-5"
          *ngIf="ShowErrorSummary"
        >
          <span style="font-size: 14px">{{ errorValidationSummary }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
